<p-dialog appDialogoPadrao="pi pi-calendar" descricao="Nova data limite para a exigência." [visible]="visible()" (visibleChange)="visible.set($event)" [style]="{ width: 'min(94vw, 420px)' }" [appendTo]="'body'" header="Prorrogar prazo">
    <form [formGroup]="form" class="flex flex-col gap-4">
        <div>
            <label class="font-semibold block mb-2">Período</label>
            <p-select appendTo="body" formControlName="periodo" [options]="opcoesPeriodo" optionLabel="label" optionValue="value" placeholder="Selecione" styleClass="w-full" />
            @if (form.get('periodo')?.touched && form.get('periodo')?.hasError('required')) {
                <small class="text-red-500">Selecione o período.</small>
            }
        </div>
    </form>

    <ng-template #footer>
        <p-button label="Cancelar" severity="secondary" [text]="true" [disabled]="salvando()" (onClick)="fechar()" />
        <p-button label="Confirmar" icon="pi pi-check" [loading]="salvando()" [disabled]="form.invalid" (onClick)="salvar()" />
    </ng-template>
</p-dialog>
